import React from 'react';

const Services = () => {
  return (
    <div>
      <h1>Services Page</h1>
    </div>
  );
};

export default Services;